import React, { useMemo } from "react";
import Star from "../../_icons/Star";
import { extractInitials } from "../../../atlas-utils";
import Popover from "../../_commons/Popover";
import SkeletonLoader from "../SkeletonLoader";

const EntityCard = ({
	classes = "",
	title = "",
	displayIcon = false,
	imgSrc = "",
	brandText = "",
	star = false,
	ratingText = false,
	rating = "",
	labelImportant = false,
	currCell = "",
	iconColor = "",
	loading = false,
	error = false,
	important = false,
	handleClickImportant = () => {},
	...rest
}) => {
	const renderPopover = (data) => {
		return <div className="entity-card-tooltip-description"> {data}</div>;
	};

	const formattedRatingText = useMemo(() => {
		const num = Number(rating);
		if (isNaN(num) || num <= 0) {
			return "";
		}
		return Number(num.toFixed(1));
	}, [rating]);

	const showSkeletonLoader = loading || error;
	return (
		<div
			className={`
				entity-card 
				${classes} 
				${star && displayIcon ? "show-icon" : ""} 
				${currCell} 
				${loading ? "loading" : error ? "error" : ""}`}
		>
			{labelImportant && (
				<div
					className={`chevron-right ${!showSkeletonLoader ? "label-important" : ""}`}
					onClick={() => !showSkeletonLoader && handleClickImportant(rest)}
				>
					{showSkeletonLoader ? (
						<SkeletonLoader classname={"label-important"} />
					) : (
						<ArrowChevronRight important={important} />
					)}
				</div>
			)}
			{displayIcon &&
				(showSkeletonLoader ? (
					<SkeletonLoader classname={"img-loading"} />
				) : imgSrc ? (
					<img className="display-icon-img" src={imgSrc} />
				) : (
					brandText && (
						<div className={`${iconColor ? "brand-initials" : ""} ${iconColor}`}>
							{extractInitials(brandText.split(" "))}
						</div>
					)
				))}
			<Popover
				data={title}
				renderPopover={renderPopover}
				showOnHover={!loading && title.length > 10}
				classes="entity-card-new-tooltip"
				position="down-left"
				tooltipPosition="down-left"
				time={0}
			>
				<div className="title">
					{showSkeletonLoader ? (
						<>
							<SkeletonLoader classname={"title-loading"} />
						</>
					) : (
						<span>{title}</span>
					)}
				</div>
			</Popover>
			<div className="ratings">
				{(star || ratingText) && showSkeletonLoader ? (
					<SkeletonLoader classname={"rating-loading"} />
				) : (
					<>
						{ratingText && <span className="rating">{formattedRatingText}</span>}
						{formattedRatingText && star && (
							<Star styles={{ width: "8.45px", height: "9px" }} variations={{ fill: "#AAAAAA" }} />
						)}
					</>
				)}{" "}
			</div>
		</div>
	);
};

export default React.memo(EntityCard);

const ArrowChevronRight = ({ important = false }) => {
	if (important) {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="red">
				<path
					d="M0.90625 11.8881L4.59228 6.23313L0.90625 0.578125H10.8942C11.1999 0.578125 11.4873 0.646167 11.7562 0.78225C12.0252 0.918333 12.2463 1.10795 12.4195 1.3511L15.9221 6.23313L12.3856 11.1319C12.218 11.3695 12.0025 11.5549 11.7392 11.6882C11.476 11.8215 11.1943 11.8881 10.8942 11.8881H0.90625Z"
					fill="#E6B917"
				/>
			</svg>
		);
	}
	return (
		<svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 11.17L4.54222 5.585L0 0H9.68002C9.87768 0 10.0638 0.045569 10.2383 0.136706C10.4129 0.227844 10.5659 0.347617 10.6974 0.496026L14.8257 5.585L10.6584 10.6935C10.5334 10.8354 10.3869 10.9503 10.2188 11.0382C10.0508 11.1261 9.87116 11.17 9.68002 11.17H0ZM2.87058 9.84993H9.37538C9.47303 9.84993 9.56417 9.82714 9.64879 9.78156C9.73343 9.736 9.80504 9.67416 9.86361 9.59604L13.115 5.585L9.86361 1.57396C9.80504 1.49584 9.73669 1.434 9.65856 1.38844C9.58044 1.34286 9.48605 1.32007 9.37538 1.32007H2.87058L6.27236 5.585L2.87058 9.84993Z"
				fill="#AAAAAA"
			/>
		</svg>
	);
};
